/**
 * tabにjs-tab
 * tabアクティブ時にis-active
 * panelにjs-panel
 * panelアクティブ時にis-active
 */
class Tab{
    constructor(){
        this.tabs = document.querySelectorAll('.js-tab');
        this.event();
    }

    event(){
        this.tabs.forEach(el => {
            el.addEventListener("click", () => { this.tabSwitch(el) });
        });
    }

    tabSwitch(el){
        // タブのclassの値を変更
        document.querySelectorAll('.is-active')[0].classList.remove('is-active');
        el.classList.add('is-active');
        // コンテンツのclassの値を変更
        document.querySelectorAll('.is-show')[0].classList.remove('is-show');
        const arrayTabs = Array.prototype.slice.call(this.tabs);
        const index = arrayTabs.indexOf(el);
        document.querySelectorAll('.js-panel')[index].classList.add('is-show');
    }
}

export default Tab